export default "__VITE_ASSET__sDPTSVl9__"